enum MetadataKey {
  MembershipProfileId = 'membershipProfileId',
  Setting = 'setting',
  ExtraProps = 'extraProps',
  WhatsappBotSetting = 'whatsappBotSetting',
  NotificationContent = 'notificationContent',
  Communication = 'communication',
  CommunicationContext = 'communicationContext',
  Venue = 'venue',
  VenueSlug = 'venueSlug',
  CompanyId = 'companyId',
  Program = 'program',

  // Used for notifcation content
  maxTitle = 'maxTitle',
  maxContent = 'maxContent',
  textEditorVariables = 'textEditorVariables',
}

export default MetadataKey
